import { ia } from 'lib/helpers/utility';

import { CONFIRMATION_MODAL } from 'components/shared/Forms/Custom/ProviderMedications/lib/constants';

export const onHandleDelete = ({ formik = {}, data, setConfirmationModal = () => null }) => {
  if (!formik) {
    return;
  }

  const dataId = data?.id || data?.tempId;

  formik.setFieldValue(
    'medications',
    formik?.values?.medications?.filter((medication) => {
      const medicationId = medication?.id || medication?.tempId;
      return medicationId !== dataId;
    })
  );

  if (data?.id) {
    formik.setFieldValue(
      'deleteMedicationIds',
      ia(formik?.values?.deleteMedicationIds)
        ? [...formik.values.deleteMedicationIds, data.id]
        : [data.id]
    );
  }

  setConfirmationModal(CONFIRMATION_MODAL);
};
